import { render, staticRenderFns } from "./BasicRadioButton.vue?vue&type=template&id=3d110850&"
import script from "./BasicRadioButton.vue?vue&type=script&lang=ts&"
export * from "./BasicRadioButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports